import axios from 'axios';
import constants from 'Constants';
import * as auth from 'Auth';
import * as paths from 'Paths';



//=================================================
// Internal Utils
//=================================================
function extractUrl(kwargs) {
  if (kwargs.url) return kwargs.url;
  return `/${constants.API_VERSION}/${kwargs.path}`;
}

function handleErrorCallback(error, errorCallback) {
  if (error.response) {
    if (error.response.status.toString().charAt(0) == "5") {
      errorCallback(["Server error. This error indicates that there are some issues on our end."]);
      return;
    }

    if (error.response.data) {
      if (error.response.data.errors) {
        errorCallback(error.response.data.errors);
        return;
      }

      errorCallback(error.response.data);
      return;
    }
  }

  errorCallback([error.message]);
}

//=================================================
// Normal Request
//=================================================
function handleRqSuccess(response, successCallback) {
  successCallback(response.data);
};


function handleRqError(error, errorCallback) {
  handleErrorCallback(error, errorCallback);
};


export function getRq(kwargs) {
  const config = {};
  config['method'] = 'get';
  config['url'] = extractUrl(kwargs);
  config['headers'] = kwargs.headers || {};

  axios(config)
    .then((response) => handleRqSuccess(response, kwargs.successCallback))
    .catch((error) => handleRqError(error, kwargs.errorCallback));
};

export function postRq(kwargs) {
  const config = {};
  config['method'] = 'post';
  config['url'] = extractUrl(kwargs);
  config['data'] = kwargs.data || "{}";
  config['headers'] = kwargs.headers || {};

  axios(config)
    .then((response) => handleRqSuccess(response, kwargs.successCallback))
    .catch((error) => handleRqError(error, kwargs.errorCallback));
};


export function buildTitanUrl(path) {
  return `${process.env.TITAN_API_SERVER}/${constants.API_VERSION}/${path}`;
}


//=================================================
// Authenticated Request
//=================================================
function handleAuthSuccess(response, successCallback) {
  successCallback(response.data);
};


function handleAuthError(error, errorCallback) {
  // For authenticated console request, will always redirect user to login page if it's 401 or 403 unauthorized error
  // since it could be expiration of api tokens
  if (error.response) {
    if (error.response.status === 401 || error.response.status === 403) {
      localStorage.clear();
      window.location = paths.getPathLogin();
      return;
    }
  }

  handleErrorCallback(error, errorCallback);
};


// Note: Convention is to pass array of errors to `errorCallback`
export function getAuth(kwargs) {
  const config = {};
  config['method'] = 'get';
  config['url'] = extractUrl(kwargs);

  let headers = kwargs.headers || {};
  headers['Authorization'] = auth.getAuthorizationToken();
  headers['X-Account'] = auth.getAccountId();
  config['headers'] = headers;

  axios(config)
    .then((response) => handleAuthSuccess(response, kwargs.successCallback))
    .catch((error) => handleAuthError(error, kwargs.errorCallback));
};


export function postAuth(kwargs) {
  const config = {};
  config['method'] = 'post';
  config['url'] = extractUrl(kwargs);
  config['data'] = kwargs.data || "{}";

  let headers = kwargs.headers || {};
  headers['Authorization'] = auth.getAuthorizationToken();
  headers['X-Account'] = auth.getAccountId();
  config['headers'] = headers;

  axios(config)
    .then((response) => handleAuthSuccess(response, kwargs.successCallback))
    .catch((error) => handleAuthError(error, kwargs.errorCallback));
};

export function patchAuth(kwargs) {
  const config = {};
  config['method'] = 'patch';
  config['url'] = extractUrl(kwargs);
  config['data'] = kwargs.data || "{}";

  let headers = kwargs.headers || {};
  headers['Authorization'] = auth.getAuthorizationToken();
  headers['X-Account'] = auth.getAccountId();
  config['headers'] = headers;

  axios(config)
    .then((response) => handleAuthSuccess(response, kwargs.successCallback))
    .catch((error) => handleAuthError(error, kwargs.errorCallback));
};

export function deleteAuth(kwargs) {
  const config = {};
  config['method'] = 'delete';
  config['url'] = extractUrl(kwargs);

  let headers = kwargs.headers || {};
  headers['Authorization'] = auth.getAuthorizationToken();
  headers['X-Account'] = auth.getAccountId();
  config['headers'] = headers;

  axios(config)
    .then((response) => handleAuthSuccess(response, kwargs.successCallback))
    .catch((error) => handleAuthError(error, kwargs.errorCallback));
};



























